import React, { useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../services/pbumku/PbumkuService";

const JenisGrade = ({ kodeSert, kodeGrade }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [uraianStatus, setUraianStatus] = useState('')

    useEffect(() => {
        const getUraianGrade = async () => {
            const response = await pbumkuService.getJenisGrade(kodeSert, kodeGrade)
            setUraianStatus(response?.data?.uraianGrade ?? '-')
        }
        getUraianGrade()
    }, [pbumkuService, kodeSert, kodeGrade])

    return (
        <>
            {uraianStatus}
        </>
    )
}

export default JenisGrade